// API URL
// export const API_URL = "https://api.hrbuddie.com";
// export const API_URL = "https://beta.api.hrbuddie.com";
// export const API_URL = "https://qa.api.hrms.hrbuddie.com";
export const API_URL = "https://dev.api.hrms.hrbuddie.com";

// local server
// export const API_URL = "http://192.168.200.99:8000";

// authentication endpoints
export const LOGIN_URL = `/authentication/login/`;
export const LOGOUT_URL = `/authentication/logout/`;
export const FORGOT_PASSWORD = `/authentication/forgotpassword/`; // not found in hrbuddie endpoints
export const CHANGE_PASSWORD = `/authentication/changepassword/`;
export const SEND_OTP = `/authentication/send_otp/`;
export const VERIFY_OTP = `/authentication/verify_otp/`;

// home screen endpoints
export const HOME = `home/`;
export const HAPPYMETER = `home/happy_meter/`;
export const CLOCKIFY = `home/clockify/`;
export const NOTIFICATION = `home/notification/`;
export const NOTIFICATION_COUNT = `home/notification/count/`;
export const ADMIN_DASHBOARD = `home/admin_dashboard/`;
export const ADMIN_DASHBOARD_PRESENCE_LIST = `home/admin_dashboard/presence_list/`;
// Org-admin Dashboard Overview: one row per branch (org admin only). Answers
// "which branch needs me", where ADMIN_DASHBOARD answers "what's due today" for
// a single branch.
export const ORG_DASHBOARD = `home/org_dashboard/`;

export const NEW_EMPLOYEE_ATTENDANCE_DAILY =  `attendance/`;
export const NEW_EMPLOYEE_ATTENDANCE_LOG = `attendance/attendance_log/`;
export const NEW_EMPLOYEE_ATTENDANCE_CORRECTION_REQUEST = `attendance/correction-request/`;

export const USERGROUP = 'administrator/user_group/'
export const USERPERMISSION = 'administrator/user_permissions/'
export const PASSWORD_POLICY = 'administrator/password_policy/'
export const NOTICE_BOARD = 'administrator/notice_board/'
export const EMPLOYER = 'administrator/company/';
export const ORGANIZATION_DOCUMENTS = 'administrator/documents'
// Branch management.
export const BRANCH = 'administrator/branches/';
// Branch transfer requests (create / list / approve) + the lightweight
// branch-scoped employee dropdown and per-request approval history.
export const BRANCH_TRANSFER = 'employee/branch_transfer/';
// Per-person branch access (branch + role + delegated CRUD grants), managed
// from the User Permission page. GET ?employee_id= reads current access;
// PUT applies changes (validated server-side against the actor's own role).
export const BRANCH_ACCESS = 'employee/branch_access/';

// master
export const EMPLOYEE_TYPE = `master/employee_type/`;
export const EMPLOYEE_DEPARTMENT = `master/departments/`;
export const EMPLOYEE_DESIGNATION = `master/designation/`;
export const EMPLOYEE_GROUP = `master/group/`;
export const EMPLOYEE_LEAVE_POLICY = `master/leave_type/`;
export const REIMBURSEMENTS_CONFIG = `master/reimbursement_type/`;
export const ASSET_MANAGEMENT = `master/asset_type/`;
export const MASTER_ASSET_CATEGORY = `master/asset_category/`;
export const MASTER_ASSET_SUBCATEGORY = `master/asset_sub_category/`;
export const LETTER_TYPE_API = `master/letter_type/`;
export const LETTER_TEMPLATE_API = `master/letter_template/`;

// configuration
export const EMPLOYEE_SHIFT = 'configuration/shift/'
export const HOLIDAY_SETUP = 'configuration/holiday/'
export const EMPLOYEE_WEEK_OFF = 'configuration/weekoff/'
export const PAYROLL_PERIOD = 'configuration/payroll_period/'
export const SALARY_COMPONENT = 'configuration/salary_component/'
export const SALARY_TEMPLATE = 'configuration/salary_template/'
export const CUSTOM_CONFIGURATION = 'configuration/custom_configuration/'
export const SUBORDINATE_SETUP = 'configuration/subordinate/'
export const SUBORDINATE_CARDS = 'configuration/cards/'

// employee
export const EMPLOYEE_PERSONAL_INFO = `employee/info/`;
export const EMPLOYEE_PROFILE = `employee/profile/`; // logged-in user's own profile (GET) + photo update (POST)
export const EMPLOYEEDOC = `employee/document/`;
export const EMPLOYEESAL = `employee/salary/`;
export const EMPLOYEEISSUEDDOC = `employee/document/issued/`;

export const EMPLOYEE_CANDIDATE_INFO = `employee/candidate/info/`;
export const EMPLOYEE_CANDIDATE_DOC = `employee/candidate/document/`
export const EMPLOYEE_CANDIDATE_SAL = `employee/candidate/salary/`
export const EMPLOYEE_CANDIDATE_ISSUEDDOC = ``; // --> this concept is skipped and handled in final stage of verification
export const EMPLOYEE_CANDIDATE_VERIFICATION = `employee/candidate/verification/`;
export const EMPLOYEE_CANDIDATE_OFFER_LETTER = `employee/offer_letter/`

export const EMPLOYEE_INTERN_INFO = `employee/interns/info/`;
export const EMPLOYEE_INTERN_DOC = `employee/interns/document/`
export const EMPLOYEE_INTERN_SAL = `employee/interns/salary/`
export const EMPLOYEE_INTERN_ISSUEDDOC = ``;  // --> this concept is skipped and handled in final stage of verification
export const EMPLOYEE_INTERN_VERIFICATION = `employee/interns/verification/`;
export const EMPLOYEE_INTERN_OFFER_LETTER = `employee/offer_letter/`

// employee request endpoints
export const LEAVE_URL = `employee/leave_request/`;
export const REIMBURSEMENT_URL = `employee/reimbursement_request/`;
export const ADVANCE_URL = `employee/advance_salary_request/`;
export const SUBORDINATES_URL = `employee/subordinates/employee_list/`;
export const SUBORDINATE_ATTENDANCE_SUMMARY_URL = `employee/subordinates/attendance_list/`;
export const RESIGNATION_URL = `employee/resignation_request/`;
export const RESIGNATION_APPROVER_URL = `employee/resignation_approver/`;
export const RESIGNATION_PROCESS_URL = `employee/resignation_process/`;

// timesheet (My Timesheet / Team Timesheet day-end reporting)
export const TIMESHEET_URL = `employee/timesheet/`;
export const TEAM_TIMESHEET_URL = `employee/team/timesheet/`;
export const TEAM_TIMESHEET_SUMMARY_URL = `employee/team/timesheet/summary/`;
export const TEAM_TIMESHEET_NOT_SUBMITTED_URL = `employee/team/timesheet/not-submitted/`;

// approval inbox
export const LEAVE_REQUEST_URL = 'employee/leave_approval/'
export const REIMBURESMENT_REQUEST_URL = 'employee/reimbursement_approval/'
export const ADVANCE_REQUEST_URL = 'employee/advance_salary_approval/'
export const RESIGNATION_REQUEST_URL = 'employee/resignation_approval/'

// payroll
export const PAYROLL_PROCESS = `payroll/payroll_process/`;
export const PAYROLL_RUN_GET = `payroll/run_payroll/`;
export const PAYROLL_SHORT_DUTY_REVIEW = `payroll/short_duty_review/`;
export const PAYROLL_TDS_SLAB = `payroll/tds_slab/`;
export const PAYROLL_TDS_PREVIEW = `payroll/tds_preview/`;
export const PAYROLL_PAYSLIP_EDIT = `/payroll/salary_edit/`
export const PAYROLL_PUBLISH = `payroll/publish_payslip/`;
export const PAYROLL_BANK_ADVICE = `payroll/bank_advice/`;
export const PAYROLL_PAY_SLIP = `payroll/payslip/`;

// attendance
export const DAYWISE_ATTENDANCE = 'attendance'
export const MONTHWISE_ATTENDANCE_LOG = 'attendance/attendance_log/'
export const EMPLOYEE_ATTENDANCE_DAILY = 'attendance/'
export const EMPLOYEE_MISSING_ATTENDANCE_CORRECTION = 'attendance/correction-request/'

// assets
export const ASSET_REGISTRY = `asset_management/asset_registry/`;
export const ASSET_EMPLOYEE_AUDIT = `asset_management/employee_audit/`;
// asset requests / tickets (employee raises, admin approves & issues)
export const ASSET_REQUEST = `asset_management/asset_request/`;
//asset registry city - floor - block - room 
export const ASSET_CITY = `asset_management/asset_city/`;
export const ASSET_BLOCK = `asset_management/asset_block/`;
export const ASSET_FLOOR = `asset_management/asset_floor/`;
export const ASSET_ROOM = `asset_management/asset_room/`;

// roster
export const ROSTERING_GET = `rostering/`;
export const INDIVIDUAL_ROSTERING_GET = `rostering/rostering_rotational_shift/`;

// reports
export const DAYWISE_ATTENDANCE_REPORTS = 'reports/attendance/day/'
export const MONTHWISE_ATTENDANCE_REPORTS = 'reports/attendance/month/'
export const SALARYPROCESS_BANK_REPORTS = 'reports/bank/'
export const SALARYSUMMARY_REPORTS = 'reports/salary_summary/'
export const PAYROLL_DETAIL_REPORTS = 'reports/payroll/'
export const EMPLOYEE_ESI_REPORTS = 'reports/esi/'
export const EMPLOYEE_PF_REPORTS = 'reports/pf/'
export const MUSTER_ROLL_REPORT = 'reports/muster_roll/'
export const EMPLOYEE_CREDIT_DEBIT = 'reports/credit_debit/'
export const EMPLOYEE_ATTENDANCE_CORRECTION = 'reports/attendance/correction/'
export const SUBORDINATES_REPORTS = 'reports/subordinates/'
export const ROSTERING_REPORT = 'reports/roster_report/'
export const LEAVE_PERMISSION_REPORT = 'reports/approved_leaves_report/'
export const SHORT_DUTY_REPORT = 'reports/short_duty/'

// data migration (employee bulk import)
export const EMPLOYEE_MIGRATION_LIST = `data_migration/employee_migration/list/`;
export const EMPLOYEE_MIGRATION_TEMPLATE = `data_migration/employee_migration/template/`;
export const EMPLOYEE_MIGRATION_PROCESS = `data_migration/employee_migration/migrate/`;
export const EMPLOYEE_MIGRATION_REPORTING_MANAGER = `data_migration/employee_migration/reporting_manager/`;

// data migration (master bulk import)
export const MASTER_MIGRATION_LIST = `data_migration/master_migration/list/`;
export const MASTER_MIGRATION_TEMPLATE = `data_migration/master_migration/template/`;
export const MASTER_MIGRATION_PROCESS = `data_migration/master_migration/migrate/`;
export const MASTER_BUNDLE_LIST = `data_migration/master_bundle/list/`;
export const MASTER_BUNDLE_TEMPLATE = `data_migration/master_bundle/template/`;
export const MASTER_BUNDLE_PROCESS = `data_migration/master_bundle/migrate/`;

// settings
export const SETTINGS_CHANGE_PASSWORD = 'employee/password/change/'

// calendar
export const CALENDAR_EVENTS = 'calendar/events/';

// ERP Integration
export const ERP_CONNECTION_STATUS = 'erp/connection/status/';
export const ERP_CONNECTION_GENERATE = '/erp/connection/generate/';
export const ERP_CONNECTION_REVOKE = '/erp/connection/revoke/';

// eMedHub (HIMS) integration — connection config + doctor sync/mapping
export const INTEGRATION_CONNECTION = 'integrations/connection/';
export const INTEGRATION_SYNC = 'integrations/sync/';
export const INTEGRATION_CONFIRM_LINK = 'integrations/sync/confirm-link/';
export const INTEGRATION_DOCTORS = 'integrations/doctors/';
export const INTEGRATION_EMPLOYEES = 'integrations/employees/';
export const INTEGRATION_MAPPINGS = 'integrations/mappings/';
export const INTEGRATION_MAPPINGS_BULK = 'integrations/mappings/bulk/';
export const INTEGRATION_DOCTOR_SHARE_DETAIL = 'integrations/doctor-share-detail/';

// training
export const TRAINING_TASKS = 'training/tasks/';
export const TRAINING_OVERVIEW = 'training/tasks/overview/';
export const TRAINING_MY_TASKS = 'training/my-tasks/';
export const TRAINING_MY_TASK_STATUS = 'training/my-tasks/status/';
export const TRAINING_ASSIGNMENT = 'training/assignments/';
export const TRAINING_TEAM_TASKS = 'training/team-tasks/';

// appraisal
export const APPRAISAL_CYCLES = 'appraisal/cycles/';
export const APPRAISAL_KPI_METRICS = 'appraisal/kpi-metrics/';
export const APPRAISALS = 'appraisal/appraisals/';
export const APPRAISAL_AUDIT = 'appraisal/appraisals/audit/';
export const APPRAISAL_ACKNOWLEDGE = 'appraisal/appraisals/acknowledge/';
export const APPRAISAL_SUBMIT = 'appraisal/appraisals/submit/';
export const APPRAISAL_RM_REVIEW = 'appraisal/appraisals/rm-review/';
export const APPRAISAL_HR_REVIEW = 'appraisal/appraisals/hr-review/';
export const APPRAISAL_PUBLISH = 'appraisal/appraisals/publish/';
export const APPRAISAL_ATTACHMENTS = 'appraisal/attachments/';

// ai copilot
// AI_CHAT is both the ask endpoint (POST) and the session list (GET).
export const AI_CHAT = 'ai/chat/';
export const AI_CHAT_HISTORY = 'ai/chat/history/';
export const AI_FEEDBACK = 'ai/feedback/';
export const AI_CONTEXT = 'ai/context/';